import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { callApi, CDN_URL, formatDate, getInlineLoader } from "../Helpers";

export default function View({ uuid }) {
  const appContext = useContext(AppContext);

  /* States */
  const [ready, setReady] = useState(false);
  const [data, setData] = useState(null);

  async function init() {
    setReady(false);
    await getData();
    setReady(true);
  }

  async function getData() {
    try {
      const response = await callApi('get-policy-data', { uuid });
      if (response.status === 1) {
        setData(response.data);
      } else {
        appContext.tellError("Could not fetch data");
      }
    } catch (error) {
      appContext.tellError("A network error occurred.");
    }
  }

  useEffect(() => {
    init();
  }, [uuid]);

  // Loading State
  if (!ready || !data) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
        {getInlineLoader()}
      </div>
    );
  }

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-10 col-xl-8">
          
          {/* Main Card Container */}
          <div className="card border-0 shadow-sm" style={{ borderRadius: "12px", overflow: "hidden" }}>
            
            {/* Header Section */}
            <div className="card-header bg-white border-bottom py-4 px-4">
              <div className="d-flex align-items-center">
                <h2 className="h4 mb-0 font-bold text-dark" style={{ letterSpacing: "-0.02em" }}>
                  {data.appName} Policies
                </h2>
              </div>
            </div>

            {/* Content Section */}
            <div className="card-body p-4 p-md-5">
              <div
                className="policy-content"
                style={{
                  lineHeight: "1.7",
                  color: "#4a5568", // Professional slate gray
                  fontSize: "1.05rem",
                  wordWrap: "break-word"
                }}
                dangerouslySetInnerHTML={{ __html: data.policy }}
              />
            </div>

          </div>

          
        </div>
      </div>

      {/* Internal CSS for Policy Content Styling */}
      <style>{`
        .policy-content h1, .policy-content h2, .policy-content h3 {
          color: #1a202c;
          margin-top: 1.5rem;
          margin-bottom: 1rem;
          font-weight: 600;
        }
        .policy-content p {
          margin-bottom: 1.25rem;
        }
        .policy-content ul {
          margin-bottom: 1.25rem;
          padding-left: 1.5rem;
        }
      `}</style>
    </div>
  );
}